import { render, staticRenderFns } from "./ExportAndCopy.vue?vue&type=template&id=3baf204c&"
import script from "./ExportAndCopy.vue?vue&type=script&lang=js&"
export * from "./ExportAndCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports